import React, { useContext } from 'react';
import './Completion.scss';
import MyContext from '../../Uttis/MyContext';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

const Completion = () => {
  const { showCompletionForm, setShowCompletionForm,fetchStudents, savenameid, url, setMessage, setSnack, setLoading } = useContext(MyContext);


  return (
    <>
      {showCompletionForm && (
        <div className="completion-modal-overlay" onClick={() => setShowCompletionForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send Completion Letter to <b>{savenameid.name}</b></h3>
              <span className="close-icon" onClick={() => setShowCompletionForm(false)}>
                &times;
              </span>
            </div>

        <Formik
  initialValues={{
    completiondate: '',
    enrollment: '',
    collegename: '',
    department: '',
    collegelocation: '',
  }}
  validationSchema={Yup.object({
    completiondate: Yup.string().required('Completion letter date is required'),
    enrollment: Yup.string().required('Enrollment number is required'),
    collegename: Yup.string().required('College name is required'),
    department: Yup.string().required('Department is required'),
    collegelocation: Yup.string().required('College location is required'),
  })}
  onSubmit={async (values, { resetForm }) => {
    setLoading(true);
    document.querySelector("body").style.overflow = "hidden";
    try {
      const payload = {
        id: savenameid.id,
        ...values,
      };
      const { data } = await axios.post(`${url}/certi-mail`, payload);
      if (data.success) {
        setSnack(true);
        setMessage(data.message);
        resetForm();
        setShowCompletionForm(false);
      } else {
        setSnack(true);
        setMessage(data.message);
      }
    } catch (error) {
      console.error("Error sending completion letter:", error);
      setSnack(true);
      setMessage("Something went wrong while sending the email.");
    } finally {
      setLoading(false);
      document.querySelector("body").style.overflow = "auto";
    }
  }}
>
  <Form className="email-form">

    <label>Completion Letter Date</label>
    <Field name="completiondate" type="date" />
    <ErrorMessage name="completiondate" component="div" className="error" />

    <label>Enrollment Number</label>
    <Field name="enrollment" type="text" />
    <ErrorMessage name="enrollment" component="div" className="error" />

    <label>College Name</label>
    <Field name="collegename" type="text" />
    <ErrorMessage name="collegename" component="div" className="error" />

    <label>Department</label>
    <Field name="department" type="text" />
    <ErrorMessage name="department" component="div" className="error" />

    <label>College Location</label>
    <Field name="collegelocation" type="text" />
    <ErrorMessage name="collegelocation" component="div" className="error" />

    <div className="form-buttons">
      <button type="submit">Send Completion Letter</button>
    </div>
  </Form>
</Formik>

          </div>
        </div>
      )}
    </>
  );
};

export default Completion;
